module.exports = {"signalrLink":"https://wuincyyrmjsd666signalr.aidixinbj.com","rechargeFlag":true,"bindCardFlag":true,"year":2018}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config/config.json
// module id = 1129
// module chunks = 75